import React from 'react';
import SearchBoxWrapper from './search-box-wrapper';


export const PublicSearch = ({
    boardCheckIn,
    boardCheckOut,
    adultsCount = 2,
    childrenCount = 0,
    petIncluded = false,
    boardId,
    locale,
    role,
    siteName,
    edapSearchType
}) => (
    <div className="trip-board-details__public-search">
        <SearchBoxWrapper
            boardId={boardId}
            arrival={boardCheckIn}
            departure={boardCheckOut}
            edapActionLocation={edapSearchType}
            guests={{adultsCount, childrenCount, petIncluded}}
            locale={locale}
            role={role}
            siteName={siteName}
            searchTextTitle={'tripboards.main.empty.planning'}
        />
    </div>
);

PublicSearch.defaultProps = {
    isMobile: false,
    boardId: null,
    role: null,
    boardCheckIn: null,
    boardCheckOut: null
};

export default PublicSearch;



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/public-search.js